export const UPDATE_DISTRIBUTION_PARTNER_STATUS = 'update_distribution_partner_status';
